import type { DrawerConfig } from '@/features/drawer/types/DrawerConfig';
import type { Theme } from '@mui/material';
import { InsuredDrawerParams } from '@/features/drawer/components/InsuredDrawer/enums/InsuredDrawerParams';
import { DRAWER_INDEX } from '@/features/drawer/constants/drawerIndex';
import { DrawerAnchor } from '@/features/drawer/enums/DrawerAnchor';
import { DrawerSize } from '@/features/drawer/enums/DrawerSize';
import { Drawers } from '@/features/drawer/enums/Drawers';
import { defaultTheme } from '@/styles/theme/defaultTheme/defaultTheme';

export const InsuredDrawerConfig: DrawerConfig = {
  theme: defaultTheme as Theme,
  anchor: DrawerAnchor.Right,
  size: DrawerSize.Normal,
  behavior: {
    isHeaderOffsetEnabled: true,
  },
  offsets: {
    right: DrawerSize.ExtraSmall,
  },
  styles: {
    common: {
      zIndex: DRAWER_INDEX,
      background: defaultTheme.palette?.background?.secondary,
    },
  },
  router: {
    allowedRoutes: ['/claim-set/'],
    drawerParam: Drawers.Insured,
    drawerExtraParamsPrefix: Drawers.Insured,
    drawerExtraParams: [
      InsuredDrawerParams.InsuredId,
      InsuredDrawerParams.ClaimSetNumber,
      InsuredDrawerParams.Highlight,
      InsuredDrawerParams.Expanded,
    ],
  },
};
